import { createStore } from 'vuex'

import betanomag from './betanomag'

import banners from './banners'
import categories from './categories'
import pages from './pages'
import posts from './posts'
import settings from './settings'
import videos from './videos'

export default createStore({
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        betanomag,
        banners,
        categories,
        pages,
        posts,
        settings,
        videos,
    }
})
